import axios from 'axios';
import toCamelCase from '../utils/camelCase';
import getExpConfig from '../utils/getExpConfig';

export const getLists = (memberId) =>
  axios({
    method: 'get',
    url: `${getExpConfig('thd-base-url')}customer/list/v1/${memberId}/lists`,
    withCredentials: true,
    headers: {
      Accept: 'application/json',
    },
  }).then((response) => toCamelCase(response.data));

export const saveToList = () =>
  axios({
    method: 'get',
    url: `${getExpConfig('thd-base-url')}list/view/savetolist`,
    withCredentials: true,
    headers: {
      Accept: 'application/json',
    },
  })
    .then((response) => toCamelCase(response.data))
    .catch((err) => {
      throw err;
    });

export const addToFavourites = ({ memberId, listId, listName, omsId }) => {
  const payload = {
    ListRequest: {
      items: [{ catentryId: omsId, qty: 1 }],
      memberId,
      listName,
      listId,
    },
  };

  return axios({
    method: 'post',
    url: `${getExpConfig('thd-base-url')}customer/list/v1/additems`,
    withCredentials: true,
    data: payload,
    headers: {
      Accept: 'application/json',
    },
  })
    .then((response) => toCamelCase(response.data))
    .catch((err) => {
      throw err;
    });
};
